import { call, put, takeLatest, select, delay } from 'redux-saga/effects';
import { set } from 'lodash';
import { objToFormData } from 'utils';
import { cleanBookState } from 'modules/common/BookingModal/actions';
import { ReservationsService, ReservCell } from '../../../../../entities/Reservations';
import {
  clearErrorBookings,
  editBookError,
  editBookRequest,
  editBookSuccess,
  getAllBooksError,
  getAllBooksRequest,
  getAllBooksSuccess,
  getCellSettingsError,
  getCellSettingsSuccess,
  getLockedCellError,
  getLockedCellRequest,
  getLockedCellSuccess,
  postBookError,
  postBookRequest,
  postBookSuccess,
  postCellRequest,
  postCellSuccess,
  putBookError,
  putBookRequest,
  putBookSuccess,
  putCellBlockAllError,
  putCellBlockAllRequest,
  putCellBlockAllSuccess,
  putCellBlockRequest,
  putCellBlockSuccess,
} from './actions';
import {
  GET_CELL_SETTINGS_REQUEST,
  GET_LOCKED_CELL_REQUEST,
  GET_MANAGER_BOOKS_REQUEST,
  POST_BOOK_REQUEST,
  POST_CELL_REQUEST,
  PUT_BLOCK_ALL_REQUEST,
  PUT_BLOCK_REQUEST,
  PUT_BOOK_REQUEST,
  PUT_EDIT_BOOK_REQUEST,
} from './constants';
import { reservationsSelector } from './selectors';
import { branchTitleSelector } from '../../../../common/LogoutBtn/selectors';

function* getResrvationsSaga(action: ReturnType<typeof getAllBooksRequest>) {
  try {
    const books: ReservCell[] = yield call(ReservationsService.getReservations, action.params);
    let unconfirmedBook = 0;

    books.forEach((book) => {
      if (book.bookingStatus && book.bookingStatus === 1) unconfirmedBook += 1;
    });

    yield put(getAllBooksSuccess(books, unconfirmedBook));
  } catch (error: any) {
    yield put(getAllBooksError(error));

    yield delay(10000);
    yield put(clearErrorBookings());
  }
}

function* postBookSaga(action: ReturnType<typeof postBookRequest>) {
  try {
    const { fromDate, toDate, editBook } = yield select(reservationsSelector);

    const val = action.payload;

    const params = {
      branchId: val?.branchId,
      from: fromDate,
      to: toDate,
    };

    const contactPhone = { number: action.payload.contactPhone.number, id: 0 };
    const internetShop = {
      name: 'Електронна черга',
      key: '00000000-0000-0000-0000-000000000000',
    };
    if (!val.bookCellId) set(val, 'bookCellId', editBook?.id);
    // eslint-disable-next-line no-prototype-builtins
    if (val.hasOwnProperty('sendSms') && val?.sendSms[0] === 'on') {
      set(val, 'sendSms', true);
    }

    set(val, 'contactPhone', contactPhone);
    set(val, 'bookingDate', action.payload.checkInDate);
    val.reservationOwner.internetShop = internetShop;

    yield call(ReservationsService.postReservations, val);
    yield put(postBookSuccess());

    yield delay(300);
    yield put(cleanBookState());
    yield put(getAllBooksRequest(params));
    yield put(getLockedCellRequest(params));
  } catch (error: any) {
    yield put(postBookError(error.errorExtraParams));

    yield delay(10000);
    yield put(clearErrorBookings());
  }
}

function* postCellSaga(action: ReturnType<typeof postCellRequest>) {
  try {
    const { checkInDate, checkOutDate, isBlocked, cellLockType } = action;

    const { fromDate, toDate } = yield select(reservationsSelector);
    // @ts-ignore
    const branch = yield select(branchTitleSelector);

    const params = {
      branchId: branch.id,
      from: fromDate,
      to: toDate,
    };

    const body = {
      branchId: branch.id,
      from: checkInDate,
      to: checkOutDate,
      isLock: isBlocked,
      cellLockType,
    };

    // @ts-ignore
    const book: ReservCell = yield call(ReservationsService.postReservationsCell, body);

    yield put(postCellSuccess(book));

    yield put(getAllBooksRequest(params));
    yield put(getLockedCellRequest(params));
  } catch (error: any) {
    yield put(postBookError(error));

    yield delay(10000);
    yield put(clearErrorBookings());
  }
}

function* putBookSaga(action: ReturnType<typeof putBookRequest>) {
  try {
    const { fromDate, toDate } = yield select(reservationsSelector);
    // @ts-ignore
    const branch = yield select(branchTitleSelector);

    const params = {
      branchId: branch.id,
      from: fromDate,
      to: toDate,
    };
    yield call(ReservationsService.putReservations, action.payload);

    yield put(putBookSuccess());

    yield delay(300);
    yield put(cleanBookState());
    yield put(getAllBooksRequest(params));
    yield put(getLockedCellRequest(params));
  } catch (error: any) {
    yield put(putBookError(error));

    yield delay(10000);
    yield put(clearErrorBookings());
  }
}

function* putBlockBookSaga(action: ReturnType<typeof putCellBlockRequest>) {
  try {
    const { fromDate, toDate } = yield select(reservationsSelector);
    // @ts-ignore
    const branch = yield select(branchTitleSelector);

    const params = {
      branchId: branch.id,
      from: fromDate,
      to: toDate,
    };
    const { cellId, isBlocked } = action;
    const body = [
      {
        cellId,
        isBlocked,
      },
    ];
    yield call(ReservationsService.putСellBlock, objToFormData(body));

    yield put(putCellBlockSuccess());

    yield delay(300);
    yield put(getAllBooksRequest(params));
    yield put(getLockedCellRequest(params));
  } catch (error: any) {
    yield put(putBookError(error));

    yield delay(10000);
    yield put(clearErrorBookings());
  }
}

function* putBlockAllSaga(action: ReturnType<typeof putCellBlockAllRequest>) {
  const dateArr = action.date.split('.');

  // @ts-ignore
  const date = `${dateArr[2]}-${dateArr[1]}-${dateArr[0]}T00:00:00`;

  try {
    const { fromDate, toDate } = yield select(reservationsSelector);
    // @ts-ignore
    const branch = yield select(branchTitleSelector);

    const params = {
      branchId: branch.id,
      from: fromDate,
      to: toDate,
    };

    const objData = {
      branchId: branch.id,
      date,
      comment: action.comment,
      isBlocked: action.isBlocked,
    };

    yield call(ReservationsService.putСellBlockDay, objToFormData(objData));

    yield put(putCellBlockAllSuccess());

    yield delay(300);
    yield put(getAllBooksRequest(params));
    yield put(getLockedCellRequest(params));
  } catch (error: any) {
    yield put(putCellBlockAllError(error));

    yield delay(10000);
    yield put(clearErrorBookings());
  }
}

function* editBookSaga(action: ReturnType<typeof editBookRequest>) {
  try {
    const { fromDate, toDate } = yield select(reservationsSelector);
    // @ts-ignore
    const branch = yield select(branchTitleSelector);

    const params = {
      branchId: branch.id,
      from: fromDate,
      to: toDate,
    };

    const val = action.payload;
    set(val, 'cellSettingId', branch.cellSetting.id);
    set(val, 'bookingDate', val.checkInDate);
    yield call(ReservationsService.editReservations, val);

    yield put(editBookSuccess());

    yield delay(300);
    yield put(cleanBookState());
    yield put(getAllBooksRequest(params));
    yield put(getLockedCellRequest(params));
  } catch (error: any) {
    yield put(editBookError(error.errorExtraParams));

    yield delay(10000);
    yield put(clearErrorBookings());
  }
}

function* getCellSettingsRequestSaga() {
  try {
    const branchLocal = localStorage.getItem('branchId') || 'null';
    const branchId = JSON.parse(branchLocal)?.id;
    // @ts-ignore
    const response = yield call(ReservationsService.getCellSettings, branchId);

    yield put(getCellSettingsSuccess(response));
  } catch (error: any) {
    yield put(getCellSettingsError(error));
  }
}

function* getLockedCellSaga(action: ReturnType<typeof getLockedCellRequest>) {
  try {
    // @ts-ignore
    const response = yield call(ReservationsService.getLockedCell, action.params);

    yield put(getLockedCellSuccess(response));
  } catch (error: any) {
    yield put(getLockedCellError(error));
  }
}

export function* reservationsWatcher() {
  yield takeLatest(PUT_BLOCK_ALL_REQUEST, putBlockAllSaga);
  yield takeLatest(PUT_BLOCK_REQUEST, putBlockBookSaga);
  yield takeLatest(POST_CELL_REQUEST, postCellSaga);
  yield takeLatest(GET_MANAGER_BOOKS_REQUEST, getResrvationsSaga);
  yield takeLatest(POST_BOOK_REQUEST, postBookSaga);
  yield takeLatest(PUT_BOOK_REQUEST, putBookSaga);
  yield takeLatest(PUT_EDIT_BOOK_REQUEST, editBookSaga);
  yield takeLatest(GET_CELL_SETTINGS_REQUEST, getCellSettingsRequestSaga);
  yield takeLatest(GET_LOCKED_CELL_REQUEST, getLockedCellSaga);
}
